import { render, staticRenderFns } from "./WizardContentFormatIndicator.vue?vue&type=template&id=00f82cbc&"
import script from "./WizardContentFormatIndicator.vue?vue&type=script&lang=ts&"
export * from "./WizardContentFormatIndicator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports